<template>
	<v-container class="px-sm pb-3xl md:px-0">
		<v-h3 tag="h1">
			{{ story.name }}
		</v-h3>

		<div class="mt-xl space-y-xl">
			<div class="space-y-lg md:grid md:grid-cols-3 md:gap-sm md:space-y-0">
				<v-storyblok-magazine-card
					v-for="content in magazinesData"
					:key="content.id"
					:magazine="content"
				/>
			</div>
		</div>
	</v-container>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

import {useStoryblokStoriesList} from "@pkg/shared/composables/use-storyblok-stories-list";

const properties = defineProps<{
	story: ISbStoryData;
}>();
const {t} = useI18n();

useSeoMeta({
	title: properties.story.content.meta.title,
	description: properties.story.content?.meta?.description ?? undefined,
});

const {
	data: {value: magazinesData},
} = await useStoryblokStoriesList("magazines", {
	starts_with: `${t("storyblok.magazines")}/`,
	is_startpage: false,
	per_page: 12,
	sort_by: "created_at:desc",
});
</script>
